<div class="task">
  <div class="task__container">
    @if (task; as currentTask) {
      @if (taskAction; as currentTaskAction) {
        <lib-task-header-info
          [task]="currentTask"
          [taskTypeAction]="taskTypeAction"
          [recentTaskNote]="recentTaskNote">
        </lib-task-header-info>

        <div class="task-pandadoc__content">
          <div class="task-pandadoc__grid">
            @if (currentTaskAction.pandaDocDocumentId) {
              <mat-card
                class="mat-mdc-card mdc-card mx-auto bg-grey-button form-home-school-registration-information">

                <div
                  class="task-pandadoc__option"
                  data-pw="task-pandadoc__container">

                  <div class="task-pandadoc__icon">
                    <i class="fas fa-file-contract fa-4x"></i>
                  </div>

                  <div class="task-pandadoc__button">
                    <button
                      mat-raised-button
                      class="save-button-small"
                      type="button"
                      (click)="openPandaDocHelper()"
                      [disabled]="isLoadingSession || !subTaskEditable()"
                      data-pw="task-pandadoc__button">

                      @if (isLoadingSession) {
                        <i
                          class="fa fa-spinner fa-spin"
                          aria-hidden="true">
                        </i>
                        Opening Document...
                      } @else {
                        <i
                          class="fa fa-file-signature"
                          aria-hidden="true">
                        </i>
                        Open Document
                      }
                    </button>
                  </div>
                </div>
              </mat-card>
            } @else {
              <p class="task-pandadoc__not-ready">
                The PandaDoc document is not ready yet.
              </p>
            }
          </div>
        </div>

        <div class="button-row">
          <button
            aria-labelledby="Cancel Action"
            class="back-btn xlarge_button secondary_materials_button"
            color="primary"
            data-qa="pandadoc_cancel_button"
            data-pw="pandadoc_cancel_button"
            mat-stroked-button
            tabindex="0"
            type="button"
            (click)="onBack()"
            (keyup)="($event.key === 'Enter' || $event.key === ' ') && onBack()">
            Cancel
          </button>
          <button
            aria-labelledby="Submit Action"
            class="submit-btn primary_materials_button xlarge_button"
            color="accent"
            data-qa="pandadoc_submit_button"
            data-pw="pandadoc_submit_button"
            mat-stroked-button
            tabindex="0"
            type="button"
            [disabled]="!canSubmit"
            (click)="onSubmit()"
            (keyup)="($event.key === 'Enter' || $event.key === ' ') && onSubmit()">
            Submit
          </button>
        </div>
      }
    }
  </div>
</div>